import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MetricScore } from 'src/app/services/metric-scores.service';
import { Observable } from 'rxjs';

@Component({
  selector: '[app-scoring-input]',
  templateUrl: './scoring-input.component.html',
  styleUrls: ['./scoring-input.component.scss']
})

export class ScoringInputComponent implements OnInit {

  rankingDisabled: boolean = false;

  @Input() metricScore: MetricScore;
  @Input() rankingId: number;
  @Input() rankingStatus: string;
  @Input() saveScoresEvent: Observable<boolean>;

  @Output() outputEvent = new EventEmitter<MetricScore>();

  constructor() { }

  ngOnInit() {

    this.saveScoresEvent.subscribe(event => {
      this.outputEvent.emit(this.metricScore);
      //console.log('--- scoring input ---');
      //console.log(this.metricScore);
    });

    if (this.rankingStatus != 'Draft') {
      this.rankingDisabled = true;
    } else {
      this.rankingDisabled = false;
    }
  }

}
